var lib_core = require("lib-core");
var PadReplicatorData = require('./padReplicatorData.js');

var GenericSmdPadGeneratorData = function (position, angle, totalNumberOfVerticalPads, totalNumberOfHorizontalPads, horizontalLeadToLeadPitch, verticalLeadToLeadPitch, pinPitch, motif) {
    PadReplicatorData.apply(this, arguments);
};

lib_core.inherit(GenericSmdPadGeneratorData, PadReplicatorData);
lib_core.JsonParser.registerClass(GenericSmdPadGeneratorData, "GenericSmdPadGeneratorData");

module.exports = GenericSmdPadGeneratorData;
